module.exports = __webpack_public_path__ + "img/PL09364.5a1d44fc.png";